import { NgModule } from '@angular/core';
import { Resizable } from './resizable.directive';
import { ResizeHandle } from './resizeHandle.directive';
var ResizableModule = (function () {
    function ResizableModule() {
    }
    return ResizableModule;
}());
export { ResizableModule };
ResizableModule.decorators = [
    { type: NgModule, args: [{
                declarations: [Resizable, ResizeHandle],
                exports: [Resizable, ResizeHandle]
            },] },
];
/** @nocollapse */
ResizableModule.ctorParameters = function () { return []; };
//# sourceMappingURL=resizable.module.js.map


//////////////////
// WEBPACK FOOTER
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/~/angular-resizable-element/dist/esm/src/resizable.module.js
// module id = ../../../../angular-resizable-element/dist/esm/src/resizable.module.js
// module chunks = 42